import React from "react";
import { Typography, LinearProgress, IconButton } from "@mui/material";
import { ChevronRight as ChevronRightIcon } from "@mui/icons-material";
import {
  StyledCard,
  StyledCardContent,
  StyledHeaderBox,
  StyledMetricValue,
  StyledProgressContainer,
  StyledStatContainer,
} from "./InsightCardShared";
import StatItem from "./StatItem";

interface InsightCardComplianceProps {
  title: string;
  complianceScore: number;
  deviations?: number;
  onClick?: () => void;
}

const InsightCardCompliance: React.FC<InsightCardComplianceProps> = ({
  title,
  complianceScore,
  deviations,
  onClick,
}) => {
  return (
    <StyledCard
      onClick={onClick}
      sx={{ cursor: onClick ? "pointer" : "default" }}
    >
      <StyledCardContent>
        <StyledHeaderBox>
          <Typography variant="subtitle2">{title}</Typography>
          <IconButton
            size="small"
            sx={{
              color: "primary.main",
              "&:hover": {
                backgroundColor: "primary.light",
                color: "white",
              },
            }}
          >
            <ChevronRightIcon />
          </IconButton>
        </StyledHeaderBox>

        <StyledMetricValue variant="h3" color="primary">
          {isNaN(complianceScore) ? "-" : complianceScore + "%"}
        </StyledMetricValue>

        <StyledProgressContainer>
          <LinearProgress
            variant="determinate"
            value={complianceScore}
            sx={{
              height: 6,
              borderRadius: 4,
              backgroundColor: "grey.200",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "success.main",
                borderRadius: 4,
              },
            }}
          />
        </StyledProgressContainer>

        {deviations !== undefined && (
          <StyledStatContainer>
            <StatItem
              label="DEVIATIONS"
              value={isNaN(complianceScore) ? "-" : deviations}
            />
          </StyledStatContainer>
        )}
      </StyledCardContent>
    </StyledCard>
  );
};

export default InsightCardCompliance;
